import Flex from "../../../../DefaultStyles/Flex";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import React, { useState } from "react";
import PartyMailModal from "../../../Party/PartyDetail/PartyDetailShareInfo/PartyMailModal";
import { Input } from "../../../../Input/Input";
import DropDown, { OptionType } from "../../../../Filters/DropDown";

export default function AllMailView() {
  const [type, setType] = useState<OptionType>({
    value: "",
    label: "조회 타입 선택",
  });
  const [email, setEmail] = useState("");
  const [emailModal, setEmailModal] = useState(false);

  return (
    <>
      <Flex gapSize={10} style={{ marginBottom: 20 }}>
        <DropDown
          boxWidth={150}
          optionList={[
            { value: "db", label: "DB 조회" },
            { value: "mailgun", label: "메일건 조회" },
          ]}
          dropdownValue={type}
          setDropDownValue={(value) => setType(value)}
        />

        <Input
          placeholder="이메일 주소 입력"
          style={{ width: 200, backgroundColor: "white" }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={type.value === ""}
        />

        <ConfirmBtn
          btnText="이메일 조회"
          btnColor="mint"
          isDisabled={email === ""}
          btnClickEvent={() => setEmailModal(true)}
        />
      </Flex>

      {emailModal && (
        <PartyMailModal
          closeEvent={() => setEmailModal(false)}
          mailId={email}
          type={type.value}
        />
      )}
    </>
  );
}
